/** GetCompanies utility catalog for one state, shared by the intake utility selects. */
import { useEffect, useState } from 'react';
import {
    fetchUtilityCompanyCatalog,
    type PreContractUtilityCompanyCatalogItem,
    type UtilityCompanyCatalogStatus,
} from '../lib/preContractUtilityPrefill';

export function usePreContractUtilityCatalog(stateCode: string): {
    catalog: PreContractUtilityCompanyCatalogItem[];
    status: UtilityCompanyCatalogStatus;
} {
    const [catalog, setCatalog] = useState<PreContractUtilityCompanyCatalogItem[]>([]);
    const [status, setStatus] = useState<UtilityCompanyCatalogStatus>('loading');

    useEffect(() => {
        let cancelled = false;
        if (!stateCode) {
            setCatalog([]);
            setStatus('empty');
            return undefined;
        }
        setStatus('loading');
        void fetchUtilityCompanyCatalog(stateCode).then((list) => {
            if (cancelled) return;
            setCatalog(list);
            setStatus(list.length > 0 ? 'ready' : 'empty');
        });
        return () => {
            cancelled = true;
        };
    }, [stateCode]);

    return { catalog, status };
}

export default usePreContractUtilityCatalog;
